<script>
    import MobileNavbar from './reusableitems/mobileNavbar.svelte';
    import CasualGames from './CasualGames.svelte';
    import ESportsSection from './ESportsSection.svelte';
    import GameSection from './GameSection.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let imgg;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            imgg,
            [
                {scale: 1, duration: 1},
                {scale: 1.4, duration: 1},
            ],
            3,
        );
    }
</script>

<section>
    <div class="navbar">
        <MobileNavbar />
    </div>
    <div class="main" bind:this={main}>
        <div class="bg-img" bind:this={imgg}>
            <!-- svelte-ignore a11y-img-redundant-alt -->
            <img
                src="images/Gamers/Gamer1.png"
                alt="Background Image"
                width="100%"
                height="100%"
            />
        </div>
        <div class="container">
            <div class="gamers"><p class="text">GAMERS</p></div>

            <div class="arrow">
                <p class="ar">></p>
            </div>
        </div>
    </div>
    <div>
        <GameSection />
    </div>
    <div><ESportsSection /></div>
    <div>
        <CasualGames />
    </div>
</section>

<style>
    .navbar {
        position: fixed;
        width: 100%;
        z-index: 1;
    }
    .arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-bottom: 8.178vw;
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: #ffffff;
        transform: rotate(90deg);
    }
    .text {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 800;
        font-size: 18.692vw;
        color: #f4eeec;
    }
    .gamers {
        margin: auto;
        justify-content: center;
        align-items: center;
        display: flex;
        height: 26.168vw;
        margin-bottom: max(13.551vw,6.2736vh);
    }
    .main {
        display: flex;
        justify-content: center;
        width: 100%;
        height: max(216vw,100vh);
        align-items: end;
        position: relative;
        overflow: hidden;
    }
    .container {
        width: 100%;
        position: absolute;
        bottom: 0;
    }
    .bg-img {
        width: 100%;
        height: max(216vw,100vh);
    }
</style>
